import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';
import { PhotoGalleryComponent } from '../../../../Components/photogallery/photogallery.component';
import { YoutubePlayerComponent } from '../../../../Components/youtube-player/youtube-player.component';
import { BaseComponent } from '../../../base.component';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../constants';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-tour',
  standalone: true,
  imports: [PageheaderComponent, PhotoGalleryComponent, YoutubePlayerComponent],
  providers: [
    SchoolApiService,
    {
      provide: YOUTUBE_PLAYER_CONFIG,
      useValue: {
        disablePlaceholder: true,
      },
    },
  ],
  templateUrl: './tour.component.html',
  styleUrl: './tour.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'about_us', path: '/about' },
    children: [{ title: 'school_tour', path: null }],
  };

  public TOUR_DATA = 'DWGB80BDP18';
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = NATIONAL_PAGES.ABOUT.TOUR;
  }
}
